import {createContext, useContext, useState, useEffect, ReactNode} from "react";

interface TypeContexteAuth {
    estConnecte: boolean;
    prenom: string | null;
    nom: string | null;
    email: string | null;
    chargementAuth: boolean;
    seConnecter: (prenom: string, nom: string, email: string) => void;
    seDeconnecter: () => Promise<void>;
}

const ContexteAuth = createContext<TypeContexteAuth | null>(null);

export function FournisseurAuth({children}: {children: ReactNode}) {
    const [estConnecte, setEstConnecte] = useState<boolean>(false);
    const [prenom, setPrenom] = useState<string | null>(null);
    const [nom, setNom] = useState<string | null>(null);
    const [email, setEmail] = useState<string | null>(null);
    const [chargementAuth, setChargementAuth] = useState<boolean>(true);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_URL}/api/auth/moi`, {
            credentials: 'include'
        }).then(res => {
            if (res.ok) return res.json();
            throw new Error();
        }).then(data => {
            setPrenom(data.prenom);
            setNom(data.nom);
            setEmail(data.email);
            setEstConnecte(true);
        }).catch(() => {
            setEstConnecte(false);
        }).finally(() => {
            setChargementAuth(false);
        });
    }, []);

    const seConnecter = (p: string, n: string, e: string) => {
        setPrenom(p);
        setNom(n);
        setEmail(e);
        setEstConnecte(true);
    };

    const seDeconnecter = async () => {
        await fetch(`${process.env.REACT_APP_API_URL}/api/auth/deconnexion`, {
            method: 'POST',
            credentials: 'include'
        });
        setEstConnecte(false);
        setPrenom(null);
        setNom(null);
        setEmail(null);
    };

    return (
        <ContexteAuth.Provider value={{
            estConnecte, prenom, nom, email,
            chargementAuth, seConnecter, seDeconnecter
        }}>
            {children}
        </ContexteAuth.Provider>
    );
}

export function useAuth() {
    const contexte = useContext(ContexteAuth);
    if (!contexte) throw new Error("useAuth doit être utilisé dans FournisseurAuth");
    return contexte;
}